$(function(){
 $('#purchase').click(function(){
     AddItemToCart();
  });   
});

function AddItemToCart(){
    var itemId = $('#product-select').val();
    if(itemId == null || typeof(itemId) == 'undefined'){
       itemId = $("input[name='id'][type='hidden']").val();
    }
	var quantity = $('#quantity').val();
	
	Shopify.addItem(itemId, quantity);
}

var UpdateCart = function(){
    Shopify.getCart();
}

function ShowMessage(msg,isError){
	if($('#ajax-response p').length > 0){
        var responseContainer = $('#ajax-response p');
		//responseContainer.text(msg);
        responseContainer.html('<a href="/cart">Checkout</a>');
        setTimeout(function(){responseContainer.html('')},6000);
	}else{
		alert(msg);
	}
}

//overides
Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  ShowMessage(data.description,true);
};

Shopify.fullMessagesFromErrors = function(errors) {
  var fullMessages = [];
  jQuery.each(errors, function(attribute, messages) {
    jQuery.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages;
}

Shopify.onCartUpdate = function(cart) {
  if(cart.item_count > 0){
    //Update Cart View function goes here
    $('#utility-cart .count').text(cart.item_count);
    var totalPrice = Shopify.formatMoney(cart.total_price, "");
    $('#utility-cart .cart-total').text(totalPrice);
    ReloadQuickCart(ShowQuickCart);
  }
  
};  

Shopify.onItemAdded = function(line_item) {
  ShowMessage(line_item.title + " was added to your cart",false);
  UpdateCart();
};

Shopify.onProduct = function(product) {
  ShowMessage(product.title,false);
};

var ShowQuickCart = function(){
  var quickCart = $('#quick-cart');
	var viewport = $.browser.safari ? $('body') : $('html');
    viewport.animate({scrollTop:0},'slow');
    quickCart.stop(true, true).slideDown(500);
    setTimeout(function(){
      if(!quickCart.hasClass('hover') && !$('#utility-cart').hasClass('hover')){
    	quickCart.delay(500).slideUp();
      }
    },3000);

};